import React from 'react';

import { PictureComponent } from 'app/components/commons/PictureComponent/PictureComponent';
import { ChannelManager } from 'app/typings/channelManagers';
import { getDerbysoftSupplierConfig } from 'app/utils/channelManagers/derbysoft';
import { format } from 'app/utils/dayjs';

import type { InventoryWithUpdates } from './InventoryHeaderUtils';
import { getLastUpdateDate } from './InventoryHeaderUtils';
import type { ChannelManagerConfig } from './channelManagerConfig';
import { getChannelManagerConfig } from './channelManagerConfig';

export type ChannelManagerInfoProps = {
  channelManager?: string;
  supplierId?: string;
  inventory?: InventoryWithUpdates;
  dateFormat?: string;
  lastUpdateLabel?: string;
  className?: string;
};

export const ChannelManagerInfo: React.FC<ChannelManagerInfoProps> = ({
  channelManager,
  supplierId,
  inventory,
  dateFormat = 'DD/MM/YYYY HH:mm',
  lastUpdateLabel = 'Last update',
  className = '',
}) => {
  const config =
    channelManager === ChannelManager.DERBYSOFT
      ? getDerbysoftSupplierConfig(supplierId)
      : getChannelManagerConfig(channelManager);
  const lastUpdateDate = getLastUpdateDate(inventory);

  return (
    <div className={`header ${className}`.trim()}>
      {config && <ChannelManagerBadge config={config} />}
      {lastUpdateDate && (
        <LastUpdateInfo
          date={lastUpdateDate}
          format={dateFormat}
          label={lastUpdateLabel}
        />
      )}
    </div>
  );
};

type ChannelManagerBadgeProps = {
  config: ChannelManagerConfig;
};

const ChannelManagerBadge: React.FC<ChannelManagerBadgeProps> = ({
  config,
}) => {
  return (
    <div className={`${config.classPrefix}-header`}>
      <div className={`${config.classPrefix}-header__thumbnail`}>
        <PictureComponent pictureId={config.iconPath} />
      </div>
      {config.name}
    </div>
  );
};

type LastUpdateInfoProps = {
  date: Date;
  format: string;
  label: string;
};

const LastUpdateInfo: React.FC<LastUpdateInfoProps> = ({
  date,
  format: dateFormat,
  label,
}) => {
  return (
    <div className="header__updated">
      {label} {format(date, dateFormat)}
    </div>
  );
};
